export default "__VITE_ASSET__CVQADSLE__"